import React, {Component, PropTypes} from 'react'

class BaronResponsiveMap extends Component {
  constructor(props) { // gives us acces to props, fires long before page load
    super(props) // assigns props to this.props
    /*all the import links are set from the config file
    kotv station radar http://s3.amazonaws.com/static.baron.web.apps/digitial_wx/pages/n2.responsive/map/index.html?initjson=https://s3.amazonaws.com/static.baron.web.apps/digitial_wx/widgets/dcms/61674fa3-d398-410d-93b1-d2c41dfa632c/live/init.js&initjsonvar=initdata
    kotv watches and warningss http://s3.amazonaws.com/static.baron.web.apps/digitial_wx/pages/n2.responsive/map/index.html?initjson=https://s3.amazonaws.com/static.baron.web.apps/digitial_wx/widgets/dcms/721d0cf2-5838-44e2-8aa9-ed637537e522/preview/init.js&initjsonvar=initdata
    kotv national radar http://s3.amazonaws.com/static.baron.web.apps/digitial_wx/pages/n2.responsive/map/index.html?initjson=https://s3.amazonaws.com/static.baron.web.apps/digitial_wx/widgets/dcms/b61ed0a3-d17a-4974-ac6d-7847825dc305/live/init.js&initjsonvar=initdata
    kwtv station radar http://s3.amazonaws.com/static.baron.web.apps/digitial_wx/pages/n2.responsive/map/index.html?initjson=https://s3.amazonaws.com/static.baron.web.apps/digitial_wx/widgets/dcms/a924a8b3-7eda-4ba8-a12a-5dce47a46a68/live/init.js&initjsonvar=initdata
    kwtv national radar http://s3.amazonaws.com/static.baron.web.apps/digitial_wx/pages/n2.responsive/map/index.html?initjson=https://s3.amazonaws.com/static.baron.web.apps/digitial_wx/widgets/dcms/3ec56385-53f3-4592-9aac-3e2761cef1ef/live/init.js&initjsonvar=initdata
    kwtv wathes and warings http://s3.amazonaws.com/static.baron.web.apps/digitial_wx/pages/n2.responsive/map/index.html?initjson=https://s3.amazonaws.com/static.baron.web.apps/digitial_wx/widgets/dcms/b52dcfcb-9247-4e97-a585-f539e0af9850/live/init.js&initjsonvar=initdata
    */
    this.affiliate = props.affiliate;
    this.container = false
    this.aspectRatio = 1000 / 750
    this.state = {
      mounted: false,
      height: 750,
      width: 1000
    }

  }


  componentDidMount() {
    if(this.container.offsetWidth > 750){
      this.setState({
        mounted: true,
        width: this.container.offsetWidth,
        height: this.container.offsetWidth / this.aspectRatio
      }, this.applyVendorJS)
    }
    else{
      this.setState({
        mounted: true,
        width: this.container.offsetWidth,
        height: this.container.offsetWidth*1.3
      }, this.applyVendorJS)
    }

  }

  applyVendorJS() {
    var skyscraper = document.getElementById('skyscraper-ad-container-map-desktop-hr');
    var iframe = document.getElementById('baron-widget-frame-map-desktop-hr');
    var wrapperWidth = document.getElementById('baron-widget-div-map-desktop-hr').offsetWidth;
    var skyscraperWidth = skyscraper.offsetWidth;
    var iframeWidth = wrapperWidth - skyscraperWidth;
    iframe.setAttribute("width", iframeWidth);
    var leaderboard = document.getElementById('leaderboard-ad-container-map-desktop-hr');
    var wrapperHeight = document.getElementById('baron-widget-div-map-desktop-hr').offsetHeight;
    var leaderboardHeight = leaderboard.offsetHeight;
    var iframeHeight = wrapperHeight - leaderboardHeight;
    iframe.setAttribute("height", iframeHeight);
    if (window.addEventListener) {
      window.addEventListener("message", function(event) {
        baron_weather_mapmaximize(event.data, event.origin);
      }, false);
    } else {
      window.attachEvent("onmessage", function() {
        baron_weather_mapmaximize(window.event.data, window.event.origin);
      });
    }
    function baron_weather_mapmaximize(domax, origin) {
      if (domax.toString() == "true") {
        iframe.style.position = "fixed";
        iframe.setAttribute("width", "100%");
        iframe.setAttribute("height", "100%");
      } else if (domax.toString() == "false") {
        iframe.style.position = "static";
        iframe.setAttribute("width", iframeWidth + "px");
        iframe.setAttribute("height", iframeHeight + "px");
      }
    }
  }

  render() { // REQUIRED
    return (<div className='gnm-baron-responsive-map' ref={(e) => {this.container = e}}>
      { this.props.technicalDifficultiesHtml ? <div dangerouslySetInnerHTML={{__html: this.props.technicalDifficultiesHtml}} ></div> : null}
      {
        this.state.mounted
          ? (<div id="baron-widget-div-map-desktop-hr" className="baron-weather-widget" style={{width: this.state.width+'px', height: this.state.height+'px'}}>
            <div id="leaderboard-ad-container-map-desktop-hr"></div>
            <iframe id="baron-widget-frame-map-desktop-hr" name="map-widget" src={this.props.iframeSrc} marginWidth="0" marginHeight="0" height="100%" width="100%" frameBorder="0" scrolling="no">
              no iframe support!
            </iframe>
            <div id="skyscraper-ad-container-map-desktop-hr"></div>
          </div>)
          : null
      }

    </div>)
  }
}

export default BaronResponsiveMap



// WEBPACK FOOTER //
// ./app/components/custom/ssr/BaronResponsiveMap/index.js